import { Stack } from 'expo-router';

const AuthLayout = () => <Stack screenOptions={{ headerShown: false }} />;

export default AuthLayout;
